import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/community/notice/page.tsx");
